import { Dialog } from '@mui/material';

import { RetailerNetworkUserDetailsLocationsTableContainer } from '../components/retailer-network-user-details-locations-table/retailer-network-user-details-locations-table.container';

type RetailerNetworkAddUserToLocationsDialogProps = {
  retailerNetworkUuid: string;
  open: boolean;
  setDialogOpen: (open: boolean) => void;
  selectLocationUuids: (locationUuids: string[]) => void;
};

export const RetailerNetworkAddUserToLocationsDialog = ({
  retailerNetworkUuid,
  open,
  setDialogOpen,
  selectLocationUuids,
}: RetailerNetworkAddUserToLocationsDialogProps) => {
  const onClose = () => setDialogOpen(false);

  return (
    <Dialog onClose={onClose} open={open} fullWidth maxWidth='md'>
      <RetailerNetworkUserDetailsLocationsTableContainer
        retailerNetworkUuid={retailerNetworkUuid}
        selectLocationUuids={selectLocationUuids}
        onClose={onClose}
      />
    </Dialog>
  );
};
